export class CampaignOptionLeaderModel {
    public data: any = null;

    public isWinner: boolean = false;

    constructor(data: any) {
        this.data = data;
    }
}